import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('existing_customer_fk_client__id_fk', ['fkClientId'], {})
@Entity('client_registration_existing')
export class ClientRegistrationExistingEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', nullable: true, unsigned: true })
	public fkClientId!: number | null;

	@Column('varchar', { name: 'firstName', length: 255 })
	public firstName!: string;

	@Column('varchar', { name: 'lastName', length: 255 })
	public lastName!: string;

	@Column('varchar', { name: 'email', length: 255 })
	public email!: string;

	@ManyToOne(
		() => ClientEntity,
		(client) => client.clientRegistrationExistings,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
